window.addEventListener('pplrAppInitiated' , function(e) {

  if($(document).find('.pplr-btn.pplr-c-button').length){
    // $(document).find('.product-personalizer').css('display', 'grid !important');
    const styleTag = document.createElement('style');
    const css = `.product-personalizer {
      display: grid !important;
    }`;
    styleTag.type = 'text/css';
    styleTag.appendChild(document.createTextNode(css));
    document.head.appendChild(styleTag);
    $(document).find('.product-modal-open').hide();
  }
  
  // const array = location.pathname.split('/');
  // const lastsegment = array[array.length-1];

  // if(lastsegment == 'mystery-football-shirt'){

    $(document).on('click', '.pplr-btn.pplr-c-button', (e) => {
        customCheckboxGenerate();
    })
  
    function customCheckboxGenerate(){
        let classes = [];
        let found = false;
        $(document).find('.pplr_checkbox_l input').each((index, elem) => {
        let parent = $(elem).parent().parent();
        let classList = $(parent).prop('classList');
        let dropClasses = ['pplr-wrapper', 'pplr-checkbox'];
        classList.forEach((value, index, obj) => {
          if(!dropClasses.includes(value) && !classes.includes(value)){
            classes.push(value);
          }
        })
      });
  
      for(let i = 0; i < classes.length; i++){
          $(document).find(`.${classes[i]} .pplr_checkbox_l input`).each((index, elem) => {
            const value = $(elem).data('value');
            const imageUrl = $(document).find(`.pplr-_${classes[i].slice(5)}-image .pplr-swatch-main.img_thumb_small .pplr-swatch-element[data-val="${value}"]`).data('image');
            if(imageUrl){
              found = true;
              let element = $(elem);
              let imageElement = `<img height="20" src="${imageUrl}" style="margin:5px;display:inline;width:20px !important">`;
              $(elem).parent().empty().append(element).append(imageElement).append(value);
            }
  
          });
        
          $(document).find(`.pplr-_${classes[i].slice(5)}-image`).hide();
        }

      if(found){
          $('.pplr_checkbox_l').css({
            'display': 'flex',
            'align-items': 'center',
            'font-family': "inherit !important"
          })
          const styleTag = document.createElement('style');
          const css = `.pplr-popup .pplr-main .pplr-wrapper.pplr-text .pplrlabel {
            font-size: 18px !important;
          }
          .pplr-popup .pplr-main .pplr-wrapper .pplrlabel{
            font-size: 18px !important;
            font-weight: 700 !important;
          }
          .pplr_checkbox_l{
            font-family: inherit !important;
          }
          .pplr-wrapper label{
            font-family: inherit !important;
          }`;
          styleTag.type = 'text/css';
          styleTag.appendChild(document.createTextNode(css));
          document.head.appendChild(styleTag);
        }
    }
  // }
  
})